import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
const POST = async ({ locals: { user }, request }) => {
  if (!user) throw error(401, "Unauthorized");
  try {
    const { cartItems } = await request.json();
    const validationResult = await prisma.$transaction(async (tx) => {
      const products = await tx.product.findMany({
        where: {
          id: { in: cartItems.map((item) => item.product.id) }
        },
        select: {
          id: true,
          name: true,
          quantity: true,
          price: true
        }
      });
      if (products.length !== cartItems.length) {
        throw error(400, "Some products are no longer available");
      }
      const productMap = new Map(products.map((p) => [p.id, p]));
      for (const item of cartItems) {
        const product = productMap.get(item.product.id);
        if (!product) {
          throw error(400, `Product ${item.product.name} not found`);
        }
        if (product.quantity < item.quantity) {
          throw error(400, `Insufficient stock for ${product.name}`);
        }
        if (product.price !== item.product.price) {
          throw error(400, `Price has changed for ${product.name}`);
        }
      }
      return true;
    });
    return json({ valid: validationResult });
  } catch (e) {
    console.error("Validation error:", e);
    throw error(e?.status || 500, e || "Validation failed");
  }
};
export {
  POST
};
